import {
  FETCH_SESSION,
  FETCH_SESSION_FULFILLED,
  FETCH_SESSION_PENDING,
  FECTH_SESSION_REJECTED,
  FETCH_SESSION_BY_DATE_PENDING,
  FETCH_SESSION_BY_DATE_FULFILLED,
  FETCH_SESSION_BY_PROPOSAL_PENDING,
  FETCH_SESSION_BY_PROPOSAL_FULFILLED , 
  FETCH_SESSION_BY_PROPOSAL_REJECTED,
  LOG_OUT
} from '../constants/ActionTypes';

import {
  BY_DATE, BY_USER
} from '../constants/Sessions'


const initialState =  { data : [], type : null, fetched: false, fetching: false }   

const sessions = (state = initialState, action) => {      
  switch (action.type) {

    case FETCH_SESSION:{                                             
        state = {...state, type: BY_USER,  fetched: false, fetching: true}                
        break;
    }
    case FETCH_SESSION_PENDING:{                                             
        state = {...state,  type: BY_USER, fetched: false, fetching: true}                
        break;
    }
    case FETCH_SESSION_FULFILLED: {                           
        state = {...state, type: BY_USER, data: action.payload.data, fetched: true, fetching: false}                

        break;
    }    
    case FECTH_SESSION_REJECTED:{             
        state = {...state, type: BY_USER, data: action.payload.data, error : true, fetched: false, fetching: false}         
        break;
    }
  
    case FETCH_SESSION_BY_DATE_PENDING:{             
        state = {...state,  fetched: false, type: BY_DATE,fetching: true}                
        break;
    }

    case FETCH_SESSION_BY_DATE_FULFILLED:{                 
        state = {...state, data: action.payload.data, type: BY_DATE, fetched: true, fetching: false}            
        break;
    }

    case FETCH_SESSION_BY_PROPOSAL_PENDING:{             
        state = {...state,  fetched: false, type: BY_DATE,fetching: true}                
        break;
    }

    case FETCH_SESSION_BY_PROPOSAL_REJECTED:{                         
        state = {...state, data: action.payload.data, type: BY_DATE, fetched: true, fetching: false}            
        break;
    }

    case FETCH_SESSION_BY_PROPOSAL_FULFILLED:{                         
        state = {...state, data: action.payload.data, type: BY_DATE, fetched: true, fetching: false}            
        break;
    }

    
    case LOG_OUT: {        
        state = {...state, fetching: false, "fetched": false, data: []};   
        break;  
    }
    default:
        break;
  }
  return state;
}

export default sessions;



// WEBPACK FOOTER //
// ./src/reducers/sessions.js